import { useDropdownContext } from './DropdownProvider.js';

var useDropdownContent = function (_a) {
    var onKeyDown = _a.onKeyDown, onBlur = _a.onBlur;
    var context = useDropdownContext();
    var contentRef = context.contentRef, keyDownHandler = context.keyDownHandler;
    return {
        context: context,
        props: {
            onKeyDown: function (event) {
                keyDownHandler(event);
                onKeyDown && onKeyDown(event);
            },
            onBlur: onBlur,
            ref: contentRef,
        },
    };
};

export { useDropdownContent };
//# sourceMappingURL=useDropdownContent.js.map
